export interface VerificationIconConfig {
  icon: string;
  color: string;
  label: string;
  description: string;
}

export function getEmailVerificationIcon(
  status: string | null | undefined
): VerificationIconConfig {
  switch (status) {
    case "DELIVERABLE":
      return {
        icon: "mdi:check-circle",
        color: "#16a34a",
        label: "Verified",
        description:
          "~2% bounce rate. Valid & safe to send — these emails will reach your contacts' inboxes.",
      };
    case "HIGH_PROBABILITY":
      return {
        icon: "mdi:check-circle",
        color: "#65a30d",
        label: "Likely Valid",
        description:
          "~9% bounce rate. Catch-all email that is likely valid based on triple verification.",
      };
    case "CATCH_ALL":
      return {
        icon: "mdi:help-circle",
        color: "#f59e0b",
        label: "Catch-All",
        description:
          "Higher bounce rate. This domain accepts all emails — address may or may not be monitored.",
      };
    case "INVALID":
      return {
        icon: "mdi:close-circle",
        color: "#dc2626",
        label: "Invalid",
        description: "Very likely to bounce. This email address does not exist or is invalid.",
      };
    case "INVALID_DOMAIN":
      return {
        icon: "mdi:close-circle",
        color: "#dc2626",
        label: "Invalid Domain",
        description: "This email domain does not exist or has no mail server.",
      };
    default:
      return {
        icon: "mdi:help-circle",
        color: "#9ca3af",
        label: "Unknown",
        description: "Email verification status is unknown — enrichment may be pending.",
      };
  }
}

export function getPhoneVerificationIcon(
  isValid: boolean | null | undefined
): VerificationIconConfig {
  if (isValid === true) {
    return {
      icon: "mdi:check-circle",
      color: "#16a34a",
      label: "Valid",
      description: "This phone number has been verified as valid.",
    };
  }
  if (isValid === false) {
    return {
      icon: "mdi:close-circle",
      color: "#dc2626",
      label: "Invalid",
      description: "This phone number has been marked as invalid.",
    };
  }
  return {
    icon: "mdi:help-circle",
    color: "#f59e0b",
    label: "Unverified",
    description: "This phone number has not been verified.",
  };
}
